import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fatchMainMenu } from 'api/mainMenu.service';
import { MainMenuItemModel } from 'types/entity';

export const MAIN_MENU_READ_STORE_NAME = 'mainMenuRead';

export const loadMainMenu = createAsyncThunk(
  `${MAIN_MENU_READ_STORE_NAME}/load`,
  async (arg: {selectedProjectId: string, mainMenuId: string}, thunkAPI) => {
    const response = await fatchMainMenu(arg.selectedProjectId, arg.mainMenuId);
    return response;
  },
);

export type MainMenuReadState = {
    loaded: boolean
    entities: { [main_menu_id: string]: MainMenuItemModel[] | undefined}
    error: any
}

export const initialMainMenuReadState: MainMenuReadState = {
  entities: {},
  loaded: false,
  error: null,
};

export const mainMenuReadSlice = createSlice({
  name: MAIN_MENU_READ_STORE_NAME,
  initialState: initialMainMenuReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadMainMenu.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadMainMenu.fulfilled, (state, action) => {
      const { main_menu_id, main_menu_items } = action.payload;
      const items = main_menu_items.sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
      state.entities = {
        ...state.entities,
        [main_menu_id || '']: items,
      };
      state.loaded = true;
    });
    builder.addCase(loadMainMenu.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const mainMenuReadAction = {
  ...mainMenuReadSlice.actions,
  loadMainMenu,
};

export default mainMenuReadSlice.reducer;
